import './DeliveryProcess.css';
import Stepper from '../../components/Stepper/Stepper';
import { TbPackage, TbReceipt, TbTruckDelivery } from 'react-icons/tb';
import { LuCalendarCheck, LuFiles, LuGalleryVertical, LuPackageSearch, LuShoppingBag, LuSmartphone, LuTruck, LuUserRoundCheck, LuUserRoundSearch } from 'react-icons/lu';
import Services from '../../Services';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Spinner from '../../components/Spinner/Spinner';

const DeliveryProcess = () => {
    const { barcode } = useParams();
    const [postData, setPostData] = useState();
    const [direction, setDirection] = useState("");
    const [activeStep, setActiveStep] = useState(0);
    const [handshakeDetail, setHandshakeDetail] = useState();

    const formatDate = (timestamp) => {
        const date = new Date(timestamp * 1000);
        const pad = (n) => n.toString().padStart(2, '0');

        const day = pad(date.getDate());
        const month = pad(date.getMonth() + 1);
        const year = date.getFullYear();
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());

        if (year === 1970) {
            return "-"
        }
        else {
            return `${day}.${month}.${year} - ${hours}:${minutes}`;
        }
    };

    useEffect(() => {
        async function fetchData() {
            try {
                const mlRes = await Services.GetMLToken();
                const token = mlRes.data.result.token;

                const today = new Date();
                const oneYearAgo = new Date(today);
                oneYearAgo.setFullYear(today.getFullYear() - 1);

                const formattedDate = `${String(oneYearAgo.getDate()).padStart(2, '0')}-${String(oneYearAgo.getMonth() + 1).padStart(2, '0')}-${oneYearAgo.getFullYear()}`;

                const postRes = await Services.GetPost(token, barcode, formattedDate);

                const data = postRes.data.result[0];
                setPostData(data);
                setDirection(data.direction);

                if (data.direction === "StoreToMallLogistics") {
                    switch (data.status) {
                        case '12': setActiveStep(0); break;
                        case '4': setActiveStep(1); break;
                        case '14': setActiveStep(2); break;
                        case '1': setActiveStep(3); break;
                        default: break;
                    }
                } else {
                    switch (data.status) {
                        case '12': setActiveStep(0); break;
                        case '4': setActiveStep(1); break;
                        case '1': setActiveStep(2); break;
                        default: break;
                    }
                }

                const handshakeRes = await Services.GetGetHandshakeDetail(token, data.handshakeID);
                const handshakeData = handshakeRes.data.result;
                setHandshakeDetail(handshakeData);

            } catch (err) {
                console.error(err);
            }
        }

        fetchData();
    }, [barcode]);


    function maskPhoneNumber(phoneNumber) {
        const str = phoneNumber.toString();
        if (str.length !== 10) {
            throw new Error('Telefon numarası 10 haneli olmalı');
        }
        const prefix = str.slice(0, 2);
        const suffix = str.slice(-2);
        const maskedMiddle = 'X'.repeat(str.length - 4);
        return `${prefix}${maskedMiddle}${suffix}`;
    }

    function maskLicensePlate(plate) {
        const str = plate.toString();
        if (str.length <= 4) {
            return str;
        }
        const firstTwo = str.slice(0, 2);
        const lastTwo = str.slice(-2);
        const maskedMiddle = 'X'.repeat(str.length - 4);
        return `${firstTwo}${maskedMiddle}${lastTwo}`;
    }

    if (!postData) {
        return (
            <div className="delivery-process-container">
                <Spinner />
            </div>
        );
    }
    else if (postData && direction === "StoreToMallLogistics") {
        return (
            <div className="delivery-process-container">
                <Stepper activeStep={activeStep} type={direction} />

                <div className="delivery-details">
                    <div className="section-title">İşlem Bilgileri</div>
                    <div className="details-row">
                        <div className="details-box"><label><TbReceipt size={17} style={{ marginRight: '3px' }} /> İrsaliye No</label><p>{postData?.handshakeID ? postData?.handshakeID : "-"}</p></div>
                        <div className="details-box"><label><LuPackageSearch size={17} style={{ marginRight: '3px' }} /> Talep No</label><p>{postData?.documentNo}</p></div>
                        <div className="details-box"><label><TbPackage size={17} style={{ marginRight: '3px' }} />Paket Adedi</label><p>{postData?.orderInventory}</p></div>
                        <div className="details-box"><label><TbTruckDelivery size={17} style={{ marginRight: '3px' }} />Teslim Firması</label><p> {postData?.shipmentFirm}</p></div>
                    </div>

                    <div className="section-title">Teslim Bilgileri</div>
                    <div className="details-row">
                        <div className="details-box"><label><LuShoppingBag size={17} style={{ marginRight: '3px' }} />Mağaza Adı</label><p>{postData?.branchTitle}</p></div>
                        <div className="details-box"><label><LuUserRoundSearch size={17} style={{ marginRight: '3px' }} />Taşıyan Porter</label><p>{postData?.porterNameLastname}</p></div>
                        <div className="details-box"><label><LuUserRoundCheck size={17} style={{ marginRight: '3px' }} />Teslim Edilen Kişi</label><p>{postData?.handover ? postData?.handover.name + " " + postData?.handover.lastname : "-"}</p></div>
                        <div className="details-box"><label><LuSmartphone size={17} style={{ marginRight: '3px' }} />Teslim Edilen Kişi Telefon</label><p>{postData?.handover ? maskPhoneNumber(postData?.handover.phone) : "-"}</p></div>
                    </div>

                    <div className="details-row">
                        <div className="details-box"><label><LuCalendarCheck size={17} style={{ marginRight: '3px' }} />Zimmete Alma Tarihi</label><p>{formatDate(postData?.on_porter_date_time)}</p></div>
                        <div className="details-box"><label><LuCalendarCheck size={17} style={{ marginRight: '3px' }} />Mal Kabule Teslim Tarihi</label><p>{formatDate(postData?.deliveredToPointDateTime)}</p></div>
                        <div className="details-box"><label><LuCalendarCheck size={17} style={{ marginRight: '3px' }} />Teslim Tarihi</label><p>{formatDate(postData?.completedDateTime)}</p></div>
                        <div className="details-box"><label><LuGalleryVertical size={17} style={{ marginRight: '3px' }} />Teslim Edilen Plaka</label><p>{postData?.handover ? maskLicensePlate(postData?.handover.note) : "-"}</p></div>
                    </div>
                </div>
            </div>
        )
    }
    else {
        return (
            <div className="delivery-process-container">
                <div className="delivery-process-container">
                    <Stepper activeStep={activeStep} type={direction} />

                    <div className="delivery-details">
                        <div className="section-title">İşlem Bilgileri</div>
                        <div className="details-row">
                            <div className="details-box"><label><TbReceipt size={17} style={{ marginRight: '3px' }} /> İrsaliye No</label><p>{postData?.handshakeID ? postData?.handshakeID : "-"}</p></div>
                            <div className="details-box"><label><LuPackageSearch size={17} style={{ marginRight: '3px' }} /> Talep No</label><p>{postData?.documentNo}</p></div>
                            <div className="details-box"><label><TbPackage size={17} style={{ marginRight: '3px' }} />Paket Adedi</label><p>{postData?.orderInventory}</p></div>
                            <div className="details-box"><label><TbTruckDelivery size={17} style={{ marginRight: '3px' }} />Teslim Firması</label><p> {postData?.shipmentFirm}</p></div>
                        </div>

                        <div className="section-title">Teslim Bilgileri</div>
                        <div className="details-row">
                            <div className="details-box"><label><LuShoppingBag size={17} style={{ marginRight: '3px' }} />Mağaza Adı</label><p>{postData?.branchTitle}</p></div>
                            <div className="details-box"><label><LuUserRoundSearch size={17} style={{ marginRight: '3px' }} />Taşıyan Porter</label><p>{postData?.porterNameLastname}</p></div>
                            <div className="details-box"><label><LuUserRoundCheck size={17} style={{ marginRight: '3px' }} />Teslim Edilen Kişi</label><p>{postData?.handover ? postData?.handover.name + " " + postData?.handover.lastname : "-"}</p></div>
                            <div className="details-box"><label><LuFiles size={17} style={{ marginRight: '3px' }} />Teslim Türü</label><p>{handshakeDetail?.confirmation_type}</p></div>
                        </div>

                        <div className="details-row">
                            <div className="details-box"><label><LuCalendarCheck size={17} style={{ marginRight: '3px' }} />Zimmete Alma Tarihi</label><p>{formatDate(postData?.on_porter_date_time)}</p></div>
                            <div className="details-box"><label><LuCalendarCheck size={17} style={{ marginRight: '3px' }} />Mal Kabule Teslim Tarihi</label><p>{formatDate(postData?.deliveredToPointDateTime)}</p></div>
                            <div className="details-box"><label><LuCalendarCheck size={17} style={{ marginRight: '3px' }} />Teslim Tarihi</label><p>{formatDate(postData?.completedDateTime)}</p></div>
                            <div className="details-box"><label><LuTruck size={17} style={{ marginRight: '3px' }} />Araç Tipi</label><p>{postData?.dataJSON.transportationTool}</p></div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};

export default DeliveryProcess;
